module.exports = __webpack_public_path__ + "static/media/organizeEvent.c3816277.png";